export const shouldEnableAppShellBootstrap = (input: {
  hasAuthenticatedSession: boolean;
  isEntryAuthFlow: boolean;
}): boolean => {
  return input.hasAuthenticatedSession && !input.isEntryAuthFlow;
};

export const shouldQueryAppShellEntitlements = (input: {
  isEntryAuthFlow: boolean;
  nonCriticalShellEnabled: boolean;
  projectsLoaded: boolean;
}): boolean => {
  return !input.isEntryAuthFlow && input.nonCriticalShellEnabled && input.projectsLoaded;
};
